import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { pushEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { LOCAL_CURRENCY_SYMBOL } from 'src/common/helpers/localized-description-helper';
import { InputField } from 'src/common/interfaces/InputField';
import { CashOfficeMenuState } from 'src/common/interfaces/states/CashOfficeMenuState';
import { AppState } from 'src/common/redux/configure-store';
import { CashOfficeActions } from 'src/common/redux/reducers/cash-office-reducer';
import { IActivity } from 'src/end-of-day/business-logic/end-of-day-status';
import EmeraldDialog from '../../../common/components/emerald-dialog/emerald-dialog';
import { CashOfficeTenderingScreen } from '../cash-office-tendering-screen/cash-office-tendering-screen';
import CashOfficeTitle from '../cash-office-title';
import { ShowVatScreen } from '../show-vat-screen/show-vat-screen';
import { styles } from './styles';

type Props = TenderCountState & TenderCountProps & typeof mapDispatchToProps;

const TenderCount: React.FC<Props> = ({
  title,
  totalSubtitleText,
  submitButtonText,
  tenderMenu,
  testId,
  submitTenderCount,
  setSelectedTenderGroup,
  onCancel,
  eodActivity,
  leftHanded,
  isProfileTaxable,
  accountName,
}): JSX.Element => {
  const classes = styles({ leftHanded });
  const [totalCountAmount, setTotalCountAmount] = useState<number>(0);
  const [vatScreen, setVatScreen] = useState<boolean>(false);
  const [vatAmount, setVatAmount] = useState<string>('');
  const { t } = useTranslation();

  const getInputCollection = (): InputField[] => {
    const selectedTenderCurrencySymbol = LOCAL_CURRENCY_SYMBOL;

    return [
      {
        label: `${t('PaidInOutTaxAmount')} (${selectedTenderCurrencySymbol})`,
        autoFocus: true,
        name: 'vat-amount',
        value: vatAmount,
      },
    ];
  };

  const submitPaidIn = (): void => {
    setVatScreen(false);
    submitTenderCount(tenderMenu, Number(vatAmount), 'VAT');
    setVatAmount('');
  };
  return (
    <EmeraldDialog open fullScreen={true} data-testid={testId}>
      <Grid
        container
        direction='column'
        className={`${classes.tenderCountContainer} fullHeight`}
        data-testid='tender-count-container'
      >
        <CashOfficeTitle
          title={t(title)}
          totalSubtitleText={t(totalSubtitleText)}
          totalCountAmount={totalCountAmount}
          accountName={accountName ? accountName : ''}
        />
        <CashOfficeTenderingScreen
          tenderMenu={tenderMenu}
          leftHanded={leftHanded}
          vatScreen={vatScreen}
          totalCountAmount={totalCountAmount}
          onCancel={onCancel}
          eodActivity={eodActivity}
          isProfileTaxable={!!isProfileTaxable}
          setVatScreen={setVatScreen}
          submitTenderCount={submitTenderCount}
          submitButtonText={t(submitButtonText)}
          setSelectedTenderGroup={setSelectedTenderGroup}
          setTotalCountAmount={setTotalCountAmount}
        />
        <ShowVatScreen
          vatAmount={vatAmount}
          vatScreen={vatScreen}
          leftHanded={leftHanded}
          setVatAmount={setVatAmount}
          setVatScreen={setVatScreen}
          getInputCollection={getInputCollection}
          onSubmit={submitPaidIn}
        />
      </Grid>
    </EmeraldDialog>
  );
};

export interface TenderCountState {
  tenderMenu: CashOfficeMenuState;
  eodActivity: IActivity[];
  leftHanded: boolean;
}

export interface TenderCountProps {
  title: string;
  totalSubtitleText: string;
  submitButtonText: string;
  testId: string;
  submitTenderCount: (
    tenderGroups: CashOfficeMenuState,
    taxAmount?: number,
    taxType?: string,
  ) => void;
  onCancel: () => void;
  isProfileTaxable?: boolean;
  accountName?: string;
}

const mapStateToProps = (state: AppState): TenderCountState => ({
  tenderMenu: state.cashOffice,
  eodActivity: state.endOfDayActivity.activity,
  leftHanded: state.cashierPreferences.leftHanded,
});

const mapDispatchToProps = {
  setSelectedTenderGroup: CashOfficeActions.setSelectedTenderGroup,
};

const TenderCountComponent = connect(mapStateToProps, mapDispatchToProps)(TenderCount);
export default TenderCountComponent;

export const ShowTenderCount = (prop: TenderCountProps): void => {
  pushEmeraldModal(<TenderCountComponent {...prop} />);
};
